var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html.enabled)?_c('div',{staticClass:"Mw-PostLogin-thankyou-custom-html"},[_c('div',{staticClass:"Mw-PostLogin-thankyou-custom-html_elems",domProps:{"innerHTML":_vm._s(_vm.html.html)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }